export default __webpack_public_path__ + "static/media/Group 728.92203af0.svg";